import CameraView from './camera-view';

export default CameraView;
